// Viewport-gap probe: at non-100% zoom Chrome's fixed-position coordinate
// space can end a scrollbar-width short of the visible right edge. Measure
// the real gap and expose it as --vp-gap so drawers/overlays extend right
// by exactly that amount. Hardened: explicit !important styles (some app
// CSS hides bare empty divs) + sanity clamp 0-60px.
(function () {
  var scheduled = false;
  function measure() {
    scheduled = false;
    if (!document.body) return;
    var p = document.createElement('div');
    p.setAttribute(
      'style',
      'position:fixed !important;right:0 !important;left:auto !important;top:0 !important;width:10px !important;height:2px !important;display:block !important;visibility:hidden !important;pointer-events:none !important;margin:0 !important;padding:0 !important;border:0 !important;z-index:-1 !important;'
    );
    document.body.appendChild(p);
    var rect = p.getBoundingClientRect();
    p.remove();
    var gap = 0;
    if (rect.width > 0) {
      gap = document.documentElement.clientWidth - rect.right;
    }
    if (!(gap > 0.5 && gap < 60)) gap = 0;
    document.documentElement.style.setProperty('--vp-gap', gap + 'px');
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(measure);
  }
  function boot() {
    measure();
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('resize', schedule);
})();